import { render, staticRenderFns } from "./SignatureRecipients.vue?vue&type=template&id=8ecc954e&"
import script from "./SignatureRecipients.vue?vue&type=script&lang=js&"
export * from "./SignatureRecipients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports